import React from 'react';
import Body from '../components/Body';
import TravelDashboard from '../components/travel/TravelDashboard';

export default function TravelPage() {
    return (
        <Body sidebar>
            <TravelDashboard />
        </Body>
    );
}
